import React from 'react';
import { Phone, Settings, Calendar, TrendingUp } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      icon: <Phone className="h-8 w-8 text-burnt-orange" />,
      title: "Quick Call",
      description: "We learn your role, workload, and biggest time-leaks."
    },
    {
      number: "2",
      icon: <Settings className="h-8 w-8 text-burnt-orange" />,
      title: "Setup & Access",
      description: "We agree on tools, workflows, boundaries, and confidentiality."
    },
    {
      number: "3",
      icon: <Calendar className="h-8 w-8 text-burnt-orange" />,
      title: "Weekly Rhythm",
      description: "We plan priorities, protect time, and handle execution."
    },
    {
      number: "4",
      icon: <TrendingUp className="h-8 w-8 text-burnt-orange" />,
      title: "Review & Improve",
      description: "We tighten systems until your week feels lighter."
    }
  ];

  return (
    <section id="how-it-works" className="section-padding bg-gray-50">
      <div className="container-center">
        {/* Section Header */}
        <div className="text-center space-y-6 mb-16 animate-slide-up">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
            How it works (simple).
          </h2>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="text-center space-y-4 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative">
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto card-shadow">
                  {step.icon}
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-burnt-orange text-white rounded-full flex items-center justify-center font-bold text-sm">
                  {step.number}
                </div>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-olive-brown mb-3">
                  Step {step.number} — {step.title}
                </h3>
                <p className="text-olive-brown/70 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Content */}
        <div className="text-center space-y-6">
          <p className="text-olive-brown/70">You can start small and expand as needed.</p>
          
          <div className="space-y-4">
            <a
              href="#contact"
              className="btn-primary"
              aria-label="Book a Quick Call - We'll recommend the right package based on your reality"
            >
              Book a Quick Call
            </a>
          </div>
            <p className="text-sm text-olive-brown/60 mt-10">
              We'll recommend the right package based on your reality.
            </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;